export default __webpack_public_path__ + "static/thriftcodes-savings-bg-bf7bade2ceaea0b71c5c5440a099c237.jpg";